export const sortFields = (a, b)=>{
    if (typeof a.row !== 'number' || typeof b.row !== 'number' || typeof a.column !== 'number' || typeof b.column !== 'number') {
        return 0;
    }
    if (a.row > b.row) {
        return 1;
    }
    if (a.row < b.row) {
        return -1;
    }
    if (a.column > b.column) {
        return 1;
    }
    if (a.column < b.column) {
        return -1;
    }
    return 0;
};
export const getSortedFields = (form, opts = {})=>{
    if (!form) {
        return [];
    }
    const { filter = ()=>true, stepId } = opts;
    const allSteps = form.steps || [];
    const steps = stepId ? allSteps.filter((step)=>step.id === stepId) : allSteps;
    return steps.map((step)=>[
            ...step.layout?.large?.items || []
        ].sort(sortFields)).flat().reduce((result, item)=>{
        const field = form.fields?.find(({ id })=>id === item.fieldId);
        if (!field || !filter(field)) {
            return result;
        }
        result.push(field);
        return result;
    }, []);
};

//# sourceMappingURL=sort-fields.js.map